import { makeAutoObservable } from 'mobx';

import { analytics } from '@/app/parts/Analytics';

import { mobx } from '@/lib/mobx';

interface AlertProps {
  title?: string;
  text?: string;
  type?: string;
  id?: string;
  redirect?: string;
  button?: { onClick: string | (() => void); text: string };
  undo?: { text?: string; callback?: () => void };
  callback?: () => void;
  progress?: boolean;
  timeout?: number | false;
  withIcon?: boolean;
  hideBtnClose?: boolean;
  iconClass?: string;
}

export class Alert {
  title: string;

  text: string;

  type: string;

  id: string;

  redirect: string | undefined;

  callback: (() => void) | undefined;

  undo: object | undefined;

  button: object | undefined;

  progress: boolean | undefined;

  timeout: number | boolean;

  timeoutId: number | null;

  withIcon: boolean | undefined;

  hideBtnClose: boolean | undefined;

  iconClass: string | undefined;

  alertDefaultTimeout: number = 5000;

  shown: boolean = false;

  constructor(props: AlertProps) {
    makeAutoObservable(this);

    this.title = props.title || '';
    this.text = props.text || '';
    this.type = props.type || 'warning';
    this.id = props.id || '';
    this.redirect = props.redirect;
    this.callback = props.callback;
    this.button = props.button;
    this.undo = props.undo;
    this.progress = props.progress;
    this.timeoutId = null;
    this.withIcon = props.withIcon;
    this.hideBtnClose = props.hideBtnClose;
    this.iconClass = props.iconClass;

    // Set the timeout or use the default value
    this.timeout = typeof props.timeout !== 'undefined' ? props.timeout : this.alertDefaultTimeout;

    // Set the timeout if it's not false
    if (this.timeout !== false) {
      this.timeoutId = window.setTimeout(() => {
        this.hide();
      }, this.timeout);
    }

    if (this.type === 'error') {
      const title = this.title ? `'${this.title}'. ` : '';
      const text = this.text ? `'${this.text}'` : '';
      analytics?.pushErrorNotification(`Error: ${title}${text}`);
    }
  }

  hide = (): void => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    if (!this.shown) {
      this.shown = true;
    }

    mobx.ui.checkAlerts();

    if (this.callback) {
      this.callback();
    }
  };
}
